import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tool-more",
  "use": "icon-tool-more-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tool-more\">\r\n  <path fill=\"currentColor\" d=\"M4.2 8a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0Zm4.9 0a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0ZM14 8a1.1 1.1 0 1 1-2.2 0A1.1 1.1 0 0 1 14 8Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol